
const has_children_menus = document.querySelectorAll('.menu-item-has-children a');
const opened_class_name = 'sub-menu-open';

has_children_menus.forEach((item, i) => {
  const submenu = item.nextElementSibling;
  if(submenu === null || !submenu.classList.contains('sub-menu')) return;
  item.addEventListener('click', (e) => {
    e.preventDefault();
    if(submenu.classList.contains(opened_class_name)){
      item.classList.remove(opened_class_name);
      submenu.classList.remove(opened_class_name);
    }else{
      item.classList.add(opened_class_name);
      submenu.classList.add(opened_class_name);
    };
    return false;
  })
  //最初から開いておく
  // if('Shopping' === item.text){
  //   item.classList.add(opened_class_name);
  //   submenu.classList.add(opened_class_name);
  // }
});
